import axios from 'axios'


export const EvaluationAPI = function () {
  const evaluationAPI_URL = "https://kitchenservice-de.herokuapp.com/evaluate";

  const dispatch = async function(payload, debug=false) {
    if ((typeof(payload) != 'object') || (payload === null)) {
      throw Error(
        "EvaluationAPI.dispatch: Payload is not an object or null but of type '"+
        typeof(payload)+"'"
      ); 
    }
    const request = {
      url: evaluationAPI_URL + "/do",
      body: {
        payload: payload
      }
    }
    // Axios just throws when the return status is not 200/OK
    try {
      await axios.post(
        request.url,
        request.body
      ); 
    } catch (e) {
      if(debug) {console.log("EvaluationDispatch/", e);}
    }
  }

  const setup = async function() {
    await axios.get(
      evaluationAPI_URL,
      {}
    ); 
  }

  return {
    dispatch,
    setup
  }
};
export const evaluationSystem = EvaluationAPI();